import { render, staticRenderFns } from "./test-item.vue?vue&type=template&id=09ef67ad&scoped=true"
import script from "./test-item.vue?vue&type=script&lang=js"
export * from "./test-item.vue?vue&type=script&lang=js"
import style0 from "./test-item.vue?vue&type=style&index=0&id=09ef67ad&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ef67ad",
  null
  
)

export default component.exports